import Select from '@cimpress/react-components/lib/Select';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { getAllCountries } from '../../../../utilities/countryHelpers';

class CountrySelector extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    className: null
  };

  onChange = countries => {
    const { onChange } = this.props;
    onChange(countries.map(({ value }) => value));
  };

  render() {
    const { t, className, disabled, value } = this.props;

    return (
      <Select
        clearable={true}
        className={className}
        disabled={disabled}
        label={t('common:commonWords.countries')}
        multi
        options={getAllCountries()}
        tether
        value={value}
        onChange={this.onChange}
      />
    );
  }
}

export default withTranslation()(CountrySelector);
